var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 58,
    viewBox: "0 0 62 58",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "k5k4i74psb",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c2z3ako4ga",
    x: 0,
    y: 0,
    width: 62,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2369"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#c2z3ako4ga)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3851",
    d: "M12 0h8a12 12 0 0 1 12 12v4a12 12 0 0 1-12 12h-8A12 12 0 0 1 0 16v-4A12 12 0 0 1 12 0z",
    transform: "translate(15 14)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 246",
    d: "M7528.426 1798.63a5.491 5.491 0 0 1 2.34-4.6 9.144 9.144 0 0 0 1.512-1.365 1.937 1.937 0 0 0-1.2-3.379 4.463 4.463 0 0 0-1.774.057 3.639 3.639 0 0 0-1.22.756 3.284 3.284 0 0 0-.5.646 1.356 1.356 0 0 1-1.789.5 1.55 1.55 0 0 1-.972-1.707 3.7 3.7 0 0 1 1.8-2.6 7.746 7.746 0 0 1 8.054.254 4.323 4.323 0 0 1 1.32 5.511 8.634 8.634 0 0 1-2.146 2.7c-.452.394-.915.778-1.337 1.2a2.7 2.7 0 0 0-.784 1.8c-.022.368-.044.736-.055 1.1a.944.944 0 0 1-.777.975 5.2 5.2 0 0 1-1.411.082.994.994 0 0 1-.941-.881c-.059-.343-.079-.698-.12-1.049z",
    transform: "translate(-7498.804 -1768.289)",
    style: {
      fill: "url(#k5k4i74psb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 247",
    d: "M7554.9 1950.754a2.2 2.2 0 0 1 2.171-2.194 2.2 2.2 0 0 1-.012 4.4 2.191 2.191 0 0 1-2.159-2.206z",
    transform: "translate(-7525.821 -1914.261)",
    style: {
      fill: "url(#k5k4i74psb)"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-help.543619b75108b4c8efb3bde3ce12779f.svg";